var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOtwDesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1406,
    height: 274,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D3D4",
    d: "M1020.22 217.559H758.839l-1.55 6.658h262.931v-6.658Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9E74B",
    d: "M948.414 217.586h-16.273v6.802h16.273v-6.802ZM847.356 217.586h-16.274v6.802h16.274v-6.802Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D3D4",
    d: "M1051.05 214.889h-30.8v11.279h30.8v-11.279Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M1051.02 214.888v-.23h-31.03v11.768h31.29v-11.768h-.26v.23h-.23v11.05h-30.31v-10.821h30.54v-.229h-.23.23Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D3D4",
    d: "M1051.08 220.543v-6.773h164.81l5.28-7.118h30.65s17.77-.201 39.49-14.983c21.73-14.781 80.37-18.943 80.37 30.051l-320.66-1.292"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M1051.34 220.543v-6.515h164.69l5.25-7.004h30.54s17.85-.229 39.64-15.039c8.41-5.74 22.5-9.902 36.53-9.902 21.87 0 43.49 10.045 43.49 39.751h.46c0-15.01-5.49-25.085-13.72-31.399a49.906 49.906 0 0 0-30.26-8.84c-14.12 0-28.27 4.162-36.82 9.988a91.654 91.654 0 0 1-27.81 13.002 65.327 65.327 0 0 1-8.44 1.693c-2.01.23-3.1.259-3.1.259h-30.77l-5.25 7.003h-164.92v7.003h.49Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D3D4",
    d: "M1051.08 220.544v6.744h164.81l5.28 7.004h30.65s17.77.2 39.49 14.982c21.73 14.781 80.37 18.971 80.37-30.022l-320.66 1.292"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M1050.85 220.544v7.003h164.92l5.25 7.003h30.8c1.04.029 2.07.115 3.1.258a85.031 85.031 0 0 1 36.25 14.667 70.414 70.414 0 0 0 36.82 9.988c10.78.4 21.39-2.702 30.25-8.84 8.24-6.315 13.72-16.389 13.72-31.371h-.48c0 29.706-21.62 39.694-43.49 39.723-14.03 0-28.12-4.133-36.53-9.902-21.79-14.81-39.58-15.011-39.64-15.011h-30.54l-5.25-7.003h-164.69v-6.515h-.49Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#193C2E",
    d: "M696.356 218.764h-17.192v4.305h17.192v-4.305Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#418F4F",
    d: "m111.994 217.559-61.795 1.062v4.534l61.795 1.062v-6.658Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#C4CCD4",
    d: "m392.205 218.561.545-.574-4.276-3.932c-2.296-2.095-4.879-4.42-6.2-5.424a13.171 13.171 0 0 0-6.285-1.981 93.366 93.366 0 0 0-12.342-.545H147.611a13.286 13.286 0 0 0-8.209 2.44c-1.033.717-4.047 3.099-6.86 5.309l-5.367 4.277h-.316v5.453l.259.23s2.439 2.238 5.08 4.563c1.32 1.206 2.698 2.382 3.875 3.387a21.719 21.719 0 0 0 2.611 2.009 14.613 14.613 0 0 0 7.118 1.579h228.436a15.269 15.269 0 0 0 10.361-3.416c1.808-1.607 8.094-8.18 8.094-8.18l.23-.229v-5.396l-.23-.23-.545.574h-.747v4.65h.775l-.545-.517-3.387 3.473c-1.808 1.837-3.817 3.904-4.649 4.621a13.805 13.805 0 0 1-9.415 3.071H145.802a13.166 13.166 0 0 1-6.371-1.291 21.256 21.256 0 0 1-2.383-1.866c-1.722-1.435-3.932-3.416-5.74-5.023l-3.157-2.87-.517.574h.775v-4.736h-.775l.488.603 5.367-4.248c2.871-2.21 5.741-4.592 6.774-5.252a11.477 11.477 0 0 1 7.348-2.181h216.122a95.22 95.22 0 0 1 12.141.516c1.95.11 3.834.745 5.453 1.837 1.206.919 3.846 3.243 6.114 5.31l4.247 3.932.517-.545"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#E06E8B",
    d: "M391.69 217.559H111.965v6.658H391.69v-6.658Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M154.239 217.559h-6.63v6.658h6.63v-6.658ZM376.422 217.559h-6.602v6.658h6.602v-6.658Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D3D4",
    d: "M750.118 217.559h-53.845l.087 6.658h52.236l1.522-6.658Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M1020.22 217.558v-.23H758.636L757 224.446h263.48v-7.118h-.26v.23h-.23v6.4H757.603l1.435-6.142h261.182v-.258h-.23.23ZM750.113 217.558v-.23h-53.931l-.057 7.118h52.581l1.694-7.118h-.287v.23l-.23-.058-1.55 6.458h-51.72l.057-6.142h53.443v-.258l-.23-.058.23.058Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D3D4",
    d: "M679.196 217.559h-47.243v6.658h47.243v-6.658Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M679.192 217.558v-.23h-47.501v7.118h47.731v-7.118h-.23v.23h-.258v6.4h-46.755v-6.142h47.013v-.258h-.258.258Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M696.56 218.562h-17.365v.488h17.365v-.488ZM696.56 222.926h-17.365v.488h17.365v-.488Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6A159",
    d: "M761.481 139.346c-27.639 0-57.948 19.89-82.631 39.665-12.342 9.874-23.277 19.747-31.572 27.123-4.219 3.703-7.778 6.774-10.562 8.898a33.76 33.76 0 0 1-3.53 2.439 4.654 4.654 0 0 1-1.923.747l-5.138.631.23 1.98 5.08-.602a6.744 6.744 0 0 0 2.87-1.005 169.79 169.79 0 0 0 19.402-15.987 465.455 465.455 0 0 1 49.482-39.636c19.057-12.6 39.55-22.244 58.292-22.215v-2.01"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D3D4",
    d: "M1373.19 232.856c-1.26 0-2.29-.631-2.29-1.377v-20.092c0-.746 1.03-1.377 2.29-1.377h30.92v22.789h-30.92"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M1373.2 232.856v-.201a2.843 2.843 0 0 1-1.52-.374.996.996 0 0 1-.4-.326c-.1-.141-.16-.305-.18-.477v-20.091c.02-.172.08-.337.18-.477.1-.141.24-.254.4-.327.46-.251.99-.38 1.52-.373h30.71v22.272h-30.71v.402h31.08v-22.99h-31.08c-1.32 0-2.47.603-2.5 1.55v20.091c0 .947 1.18 1.55 2.5 1.579v-.201M1249.98 208.143h2.15c6 0 23.37-.603 35.56-7.262a61.697 61.697 0 0 1 27.64-6.572c15.85 0 30.77 6.601 30.77 27.094h.38c0-10.304-3.82-17.221-9.65-21.469a36.41 36.41 0 0 0-21.58-5.998 61.61 61.61 0 0 0-27.81 6.63c-12.09 6.601-29.42 7.233-35.39 7.233h-2.16v.373"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M1249.98 233.429h2.12c6 0 23.34.631 35.42 7.233a61.624 61.624 0 0 0 27.81 6.63 36.5 36.5 0 0 0 21.59-5.999c5.74-4.305 9.64-11.194 9.64-21.469h-.46c0 20.378-15.01 27.066-30.85 27.094a61.298 61.298 0 0 1-27.64-6.572c-12.2-6.659-29.56-7.262-35.59-7.262h-2.13v.345"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M1249.98 206.766h-.49v27.553h.49v-27.553ZM1371.73 221.26h-25.34v.373h25.34v-.373Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#221F20",
    d: "M1294.75 228.206v.201a8.324 8.324 0 0 0 5.34-2.702 8.326 8.326 0 0 0 2.14-5.579c0-2.061-.76-4.049-2.14-5.579a8.318 8.318 0 0 0-5.34-2.701h-37.31a8.317 8.317 0 0 0-5.33 2.701 8.336 8.336 0 0 0-2.15 5.579 8.336 8.336 0 0 0 7.48 8.281h37.31v-.431h-37.31a7.9 7.9 0 0 1-7.07-7.85 7.9 7.9 0 0 1 7.07-7.85h37.31a7.925 7.925 0 0 1 5.05 2.568 7.913 7.913 0 0 1 0 10.564 7.925 7.925 0 0 1-5.05 2.568v.23Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#DB4375",
    d: "M631.693 217.559H386.84v6.658h244.824l.029-6.658Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 2,
    height: 2,
    x: 1018,
    y: 228,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1019.3 228.951h-1.06v.459h1.06v-.459Z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 4,
    height: 2,
    x: 1017,
    y: 228,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1020.19 228.291h-2.61v1.693h2.61v-1.693Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M1017.58 228.291h2.583v1.665h-2.583z"
  })))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#A8AAAC",
    d: "M1327.47 218.534c-.25-.43-.51-.861-.8-1.263l-.4-.488-.66-.487c-.4-.25-.85-.407-1.32-.46l-1.29-.172c-.78-.086-1.57-.086-2.36 0a1.97 1.97 0 0 0-.91 0c-.94.23-1.8.717-2.47 1.407-.37.311-.7.668-.98 1.061l-.37.402c-.24.288-.43.606-.58.947l-.28.689v.201a5.62 5.62 0 0 1 .86-2.152 9.364 9.364 0 0 1 2.01-2.153l-.61.373-.34.258c-.39.397-.75.83-1.06 1.292-.2.379-.38.772-.52 1.177-.05.312-.12.619-.23.918v.546-.259l.43-.631c.27-.346.55-.672.86-.976l.52-.488.17-.172.55-.459a4.672 4.672 0 0 1 2.09-.948h2.01c.27-.057.54-.057.81 0h.23c.6.091 1.18.286 1.72.574l.23.201.14.201c.4.561.66 1.211.75 1.895v1.435l-.18.602c-.13.442-.24.893-.31 1.349v.287l-.2.517c-.06.31-.19.604-.38.861l-.23.344a2.83 2.83 0 0 1-.88 1.005l-.72.402c-.32.228-.66.429-1.01.603l.26-.201h-.2l-.37.201c-.38.229-.75.344-1.12.545h-.35c-.55-.023-1.1-.12-1.63-.287h-.4a3.425 3.425 0 0 1-1.58-1.751 3.87 3.87 0 0 1-.35-1.378v-1.291l-.26.545c-.05.323-.05.653 0 .976.06.382.16.758.29 1.119l.2.46.23.344c.27.409.6.777.98 1.091.78.51 1.63.915 2.52 1.205.42.144.88.144 1.3 0h.48l-.57.201a2.87 2.87 0 0 1-2.01-.201c-.37 0-.72-.287-1.09-.402a6.781 6.781 0 0 1-.83-.459l-.32-.172.26.287c.46.376.98.659 1.55.832l.77.287h1.44a5.74 5.74 0 0 0 2.87-1.291c.59-.482 1.13-1.01 1.64-1.579.31-.43.66-.861.94-1.32l.38-.718.23-.66c.1-.279.18-.567.23-.861v-.287c.02-.372.02-.747 0-1.119a3.969 3.969 0 0 0-.18-.833c.03-.421-.04-.842-.2-1.234a7.046 7.046 0 0 0-.51-1.062 7.879 7.879 0 0 0-.78-1.09l-.23-.173-.37-.344a8.684 8.684 0 0 0-1.15-.517c.28.056.55.143.8.259h.66c.26.201.49.43.75.602l.17.173c.2.258.4.488.58.746v.201c.14.258.31.516.43.775.05.335.19.65.4.918a3.772 3.772 0 0 0-.17-.746 1.907 1.907 0 0 0-.29-.832"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#96989A",
    d: "M1308.79 228.608c.46.804 1 1.608 1.52 2.383.26.315.49.631.75.918l.22.23c.4.347.82.664 1.27.947.76.464 1.61.767 2.49.89.84 0 1.64.258 2.44.315 1.51.115 3.02.057 4.51-.172.58-.034 1.16-.111 1.72-.23a10.378 10.378 0 0 0 5.17-2.554c.68-.613 1.3-1.285 1.86-2.009l.66-.775c.44-.547.81-1.144 1.1-1.78.21-.437.39-.887.54-1.348l.17-.374a11.457 11.457 0 0 1-1.66 4.133 22.601 22.601 0 0 1-3.82 4.105c.44-.169.84-.445 1.15-.804l.69-.545h.14c.74-.769 1.42-1.594 2.04-2.469.39-.713.72-1.463.98-2.238.17-.603.31-1.177.45-1.78v-.976l-.2.201-.23.459c-.25.431-.54.833-.83 1.235a14.68 14.68 0 0 1-1.63 1.837l-.98.947-.17.172-.26.287c-.37.258-.69.631-1.06.89a9.757 9.757 0 0 1-3.96 1.779c-.71.058-1.42.058-2.13 0h-1.69c-.51.115-1.04.115-1.55 0h-.43a9.702 9.702 0 0 1-3.33-1.119l-.43-.373-.2-.201-.26-.402a8.338 8.338 0 0 1-1.41-3.616 7.333 7.333 0 0 1 0-1.148v-.976a11.01 11.01 0 0 1 0-1.407c.09-.391.2-.775.35-1.148.23-.839.4-1.692.51-2.554l.15-.603c0-.316.26-.603.37-.918.2-.572.44-1.129.72-1.665l.43-.66v-.23c.28-.392.62-.74 1-1.033l.23-.201h.2l1.35-.804c.61-.435 1.27-.801 1.95-1.09h.41c-.49.574-1.44.889-1.87 1.406v.258l.37-.172c.26 0 .49-.316.75-.43l2.12-.976.64-.201h.45l.44.172h.14c.96-.025 1.92.033 2.87.172l.49.201h.2l.28.172c1.3.758 2.3 1.917 2.87 3.301.41.824.63 1.724.67 2.641v.889c-.09.31-.09.638 0 .948.23-.3.39-.656.45-1.034.12-.616.12-1.249 0-1.865a7.942 7.942 0 0 0-.48-2.153 9.33 9.33 0 0 0-.38-.89v-.172l-.17-.316-.4-.631v-.144a8.876 8.876 0 0 0-1.9-2.037 22.79 22.79 0 0 0-4.73-2.354 4.236 4.236 0 0 0-2.53-.172 4.8 4.8 0 0 0-.92.201c.38-.164.76-.298 1.15-.402h.4l.84-.172c.38.039.77.106 1.15.201h.14l1.23.402c.72.225 1.42.493 2.1.803.55.227 1.09.496 1.61.804l.57.316v-.259l-.49-.545a9.928 9.928 0 0 0-2.87-1.579 12.78 12.78 0 0 0-1.49-.545h-.23l-.43-.172-.83-.144h-1.12a11.174 11.174 0 0 0-5.48 2.469c-1.1.873-2.13 1.833-3.08 2.87-.6.832-1.29 1.607-1.8 2.468-.52.861-.46.919-.72 1.378-.15.43-.32.832-.46 1.263-.14.43-.29 1.09-.4 1.636v2.583c.06.524.17 1.042.31 1.55 0 .516.23 1.549.43 2.324.25.708.57 1.39.95 2.038.41.756.91 1.46 1.49 2.095l.2.173.43.401.72.632c.7.374 1.43.691 2.18.947h-.46a7.191 7.191 0 0 1-1.49-.517h-.69l-.49-.315c-.51-.345-.94-.804-1.46-1.12l-.31-.315a12.13 12.13 0 0 1-1.04-1.407l-.2-.43c-.26-.488-.6-.947-.83-1.464-.23-.517-.26-1.32-.75-1.722-.01.484.09.964.29 1.406v.201c.12.553.31 1.092.54 1.607"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#949598",
    d: "m751.434 210.611-4.793 19.977.688.172 4.794-19.976-.689-.173ZM760.132 210.611l-4.765 19.977.689.172 4.764-19.976-.688-.173Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#193C2E",
    d: "M50.199 218.906H.258v4.047h49.94v-4.047Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M774.168 136.626c.54-1.08 1.32-1.9 2.34-2.5 1-.6 2.18-.9 3.52-.9 1.54 0 2.84.42 3.88 1.26 1.04.84 1.7 1.98 1.98 3.42h-1.72c-.28-.96-.78-1.72-1.5-2.26-.74-.54-1.64-.82-2.68-.82-.96 0-1.82.24-2.56.7-.74.48-1.3 1.12-1.7 1.96-.4.84-.6 1.8-.6 2.86 0 1.08.2 2.02.6 2.86.4.84.96 1.5 1.7 1.96.72.48 1.56.7 2.52.7.84 0 1.6-.16 2.28-.48.68-.32 1.2-.8 1.58-1.4.38-.6.58-1.32.58-2.14v-.48h-4.2v-1.6h5.9v7.58h-1.44l-.18-2.22c-.4.64-.98 1.18-1.74 1.64-.78.48-1.72.7-2.8.7-1.28 0-2.42-.3-3.42-.9-1-.6-1.78-1.42-2.34-2.5-.56-1.08-.82-2.32-.82-3.72 0-1.4.26-2.64.82-3.72Zm23.282.52v10.2h-1.42l-.22-1.36c-.78 1-1.86 1.48-3.26 1.48-1.22 0-2.2-.36-2.92-1.12-.74-.74-1.1-1.92-1.1-3.52v-5.68h1.64v5.58c0 1.06.22 1.86.68 2.42.46.56 1.12.82 1.98.82.92 0 1.66-.32 2.18-1 .52-.66.8-1.56.8-2.72v-5.1h1.64Zm3.915-3.64c.2.2.3.46.3.76 0 .32-.1.56-.3.76-.2.2-.46.3-.76.3-.32 0-.56-.1-.76-.3-.2-.2-.3-.44-.3-.76 0-.3.1-.56.3-.76.2-.2.44-.3.76-.3.3 0 .56.1.76.3Zm-1.58 3.64h1.64v10.2h-1.64v-10.2Zm13.667-3.8v14h-1.42l-.22-1.64c-.86 1.18-2.02 1.76-3.5 1.76-.96 0-1.8-.2-2.54-.62-.74-.4-1.32-1-1.74-1.8-.42-.78-.62-1.72-.62-2.8 0-1.02.2-1.92.62-2.72.42-.78 1-1.4 1.76-1.84.74-.44 1.58-.66 2.52-.66.82 0 1.52.16 2.12.46.58.3 1.04.7 1.38 1.22v-5.36h1.64Zm-3.24 12.2c.52-.32.92-.76 1.2-1.32.28-.56.42-1.22.42-1.94s-.14-1.38-.42-1.96a3.18 3.18 0 0 0-1.2-1.36c-.52-.32-1.1-.48-1.74-.48-1.02 0-1.84.36-2.46 1.06-.62.7-.92 1.6-.92 2.7 0 1.12.3 2.02.92 2.72.62.7 1.44 1.04 2.46 1.04.64 0 1.22-.14 1.74-.46Zm5.814-6.04c.4-.78.98-1.38 1.72-1.82.72-.44 1.56-.66 2.52-.66.92 0 1.76.2 2.48.58.72.4 1.28.96 1.7 1.68.4.74.62 1.6.66 2.58 0 .16-.02.38-.04.7h-7.92v.14c.02 1 .32 1.8.92 2.4.58.6 1.34.9 2.3.9.72 0 1.34-.18 1.86-.54.52-.36.86-.88 1.04-1.54h1.66c-.2 1.04-.7 1.9-1.5 2.56-.8.66-1.78.98-2.94.98-1.02 0-1.9-.2-2.66-.64a4.509 4.509 0 0 1-1.78-1.84c-.42-.8-.62-1.7-.62-2.74 0-1.04.2-1.94.6-2.74Zm7.38 1.7c-.08-.86-.42-1.54-.98-2.02s-1.28-.72-2.14-.72c-.78 0-1.46.26-2.04.76-.6.52-.92 1.18-1 1.98h6.16Zm2.418-4.06h1.72l2.54 8.3 2.68-8.3h1.52l2.54 8.3 2.66-8.3h1.66l-3.4 10.2h-1.8l-2.46-7.58-2.56 7.58-1.8.02-3.3-10.22Zm18.285-3.64c.2.2.3.46.3.76 0 .32-.1.56-.3.76-.2.2-.46.3-.76.3-.32 0-.56-.1-.76-.3-.2-.2-.3-.44-.3-.76 0-.3.1-.56.3-.76.2-.2.44-.3.76-.3.3 0 .56.1.76.3Zm-1.58 3.64h1.64v10.2h-1.64v-10.2Zm9.167 0v1.6h-.82c-.98 0-1.68.34-2.1.98-.42.66-.62 1.46-.62 2.42v5.2h-1.64v-10.2h1.42l.22 1.54c.28-.46.66-.84 1.14-1.12.46-.28 1.1-.42 1.94-.42h.46Zm1.253 2.36c.4-.78.98-1.38 1.72-1.82.72-.44 1.56-.66 2.52-.66.92 0 1.76.2 2.48.58.72.4 1.28.96 1.7 1.68.4.74.62 1.6.66 2.58 0 .16-.02.38-.04.7h-7.92v.14c.02 1 .32 1.8.92 2.4.58.6 1.34.9 2.3.9.72 0 1.34-.18 1.86-.54.52-.36.86-.88 1.04-1.54h1.66c-.2 1.04-.7 1.9-1.5 2.56-.8.66-1.78.98-2.94.98-1.02 0-1.9-.2-2.66-.64a4.509 4.509 0 0 1-1.78-1.84c-.42-.8-.62-1.7-.62-2.74 0-1.04.2-1.94.6-2.74Zm7.38 1.7c-.08-.86-.42-1.54-.98-2.02s-1.28-.72-2.14-.72c-.78 0-1.46.26-2.04.76-.6.52-.92 1.18-1 1.98h6.16Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#e)",
    strokeDasharray: "2.87 2.87",
    strokeMiterlimit: 10,
    strokeWidth: 1.435,
    d: "M54.531 212.335V51.348"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#f)",
    strokeDasharray: "2.87 2.87",
    strokeMiterlimit: 10,
    strokeWidth: 1.435,
    d: "M623.082 212.335V51.348"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    stroke: "#F69A4D",
    d: "M58.531.5H620.66a3.5 3.5 0 0 1 3.5 3.5v44.18a3.5 3.5 0 0 1-3.5 3.5H58.531a3.5 3.5 0 0 1-3.5-3.5V4a3.5 3.5 0 0 1 3.5-3.5Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M233.286 31.582c-.72 1.296-1.704 2.328-2.952 3.048-1.272.744-2.712 1.104-4.32 1.104-1.632 0-3.072-.36-4.32-1.104-1.272-.72-2.256-1.752-2.952-3.048-.72-1.296-1.056-2.76-1.056-4.392 0-1.608.336-3.072 1.056-4.368a7.734 7.734 0 0 1 2.952-3.072c1.248-.72 2.688-1.104 4.32-1.104 1.608 0 3.048.384 4.32 1.104 1.248.744 2.232 1.776 2.952 3.072.696 1.296 1.056 2.76 1.056 4.368 0 1.632-.36 3.096-1.056 4.392Zm-11.352-1.56c.384.84.912 1.488 1.632 1.968.696.48 1.512.696 2.448.696.912 0 1.704-.216 2.424-.696a4.722 4.722 0 0 0 1.632-1.968c.384-.816.576-1.776.576-2.832 0-1.056-.192-1.992-.576-2.832a4.804 4.804 0 0 0-1.632-1.944c-.72-.48-1.512-.72-2.424-.72-.936 0-1.752.24-2.448.72-.72.48-1.248 1.128-1.632 1.944-.384.84-.576 1.776-.576 2.832 0 1.056.192 2.016.576 2.832Zm12.647-11.232h13.296v3.096h-4.848V35.59h-3.6V21.886h-4.848V18.79Zm14.105 0 3.72-.024 3.096 12.288 3.288-12.264h3.24l3.192 12.264 3.168-12.264h3.648l-4.656 16.8h-4.152l-2.904-11.16-2.832 11.16h-4.152l-4.656-16.8Zm34.062 11.328c.048.84.384 1.512 1.008 2.016s1.44.744 2.472.744c.84 0 1.536-.168 2.064-.528s.816-.864.816-1.512c0-.432-.168-.792-.456-1.056-.288-.264-.72-.48-1.248-.624a56 56 0 0 0-2.472-.576c-1.104-.192-2.04-.456-2.784-.792a4.455 4.455 0 0 1-1.848-1.464c-.48-.648-.696-1.512-.696-2.592 0-.96.264-1.848.792-2.616s1.272-1.368 2.232-1.8c.96-.432 2.04-.672 3.24-.672 1.224 0 2.328.24 3.312.696.984.456 1.752 1.08 2.328 1.872.576.816.864 1.704.888 2.712h-3.528c-.096-.72-.384-1.296-.912-1.728-.528-.432-1.224-.672-2.088-.672-.816 0-1.44.168-1.92.504-.48.336-.72.816-.72 1.44 0 .456.144.816.432 1.056.288.24.696.456 1.224.6a27.24 27.24 0 0 0 2.448.528c1.104.216 2.064.48 2.832.792a4.352 4.352 0 0 1 1.848 1.416c.48.624.72 1.464.72 2.52a4.805 4.805 0 0 1-.84 2.76c-.576.816-1.344 1.44-2.352 1.896-1.008.48-2.112.696-3.36.696-1.344 0-2.544-.24-3.6-.72s-1.872-1.176-2.448-2.04a4.966 4.966 0 0 1-.912-2.904l3.528.048Zm12.288-4.008a5.525 5.525 0 0 1 2.184-2.208c.936-.528 2.016-.792 3.264-.792 1.248 0 2.328.264 3.288.744a5.307 5.307 0 0 1 2.232 2.064c.528.888.816 1.92.84 3.12 0 .432-.048.816-.096 1.152h-8.952v.096c.072.912.36 1.608.864 2.112.48.528 1.176.768 2.04.768.672 0 1.248-.144 1.704-.432.456-.288.768-.744.912-1.32h3.336a5.183 5.183 0 0 1-.936 2.208c-.504.672-1.152 1.176-1.968 1.56-.816.384-1.752.552-2.808.552-1.392 0-2.568-.24-3.576-.768-1.008-.504-1.776-1.224-2.304-2.184-.528-.96-.792-2.064-.792-3.336 0-1.272.24-2.376.768-3.336Zm8.424 1.872c-.12-.744-.432-1.32-.936-1.728-.504-.408-1.128-.624-1.896-.624-.744 0-1.368.216-1.872.648-.504.432-.792.984-.888 1.704h5.592Zm15.29 6.48c-1.056.864-2.4 1.272-4.056 1.272-1.296 0-2.4-.24-3.36-.768a5.55 5.55 0 0 1-2.232-2.232c-.528-.96-.768-2.064-.768-3.312 0-1.248.24-2.352.768-3.312s1.272-1.68 2.232-2.208c.96-.528 2.088-.792 3.384-.792 1.632 0 2.976.432 4.032 1.272 1.032.84 1.68 1.992 1.92 3.48h-3.504c-.144-.6-.432-1.08-.864-1.44-.432-.36-.984-.552-1.608-.552-.888 0-1.584.336-2.112.984-.528.672-.792 1.512-.792 2.568s.264 1.92.792 2.568c.528.672 1.224.984 2.112.984.648 0 1.2-.168 1.632-.552.432-.36.72-.864.864-1.512h3.48c-.24 1.512-.864 2.688-1.92 3.552Zm4.663-8.352h-2.04v-2.856h2.04v-3.456h3.384v3.456h2.808v2.856h-2.808v5.4c0 .432.072.744.264.936.192.192.504.288.936.288h1.752v2.856h-2.808c-2.352 0-3.528-1.176-3.528-3.528V26.11Zm10.979-7.44c.36.36.552.816.552 1.344 0 .552-.192 1.008-.552 1.368-.384.384-.84.552-1.392.552-.576 0-1.032-.168-1.416-.552-.384-.36-.552-.816-.552-1.368 0-.528.168-.984.552-1.344.384-.36.84-.552 1.416-.552.552 0 1.008.192 1.392.552Zm-3.096 4.584h3.384V35.59h-3.384V23.254Zm8.454 11.712c-.984-.528-1.752-1.272-2.28-2.232-.528-.96-.792-2.064-.792-3.312 0-1.248.264-2.352.792-3.312s1.296-1.68 2.28-2.208c.984-.528 2.136-.792 3.432-.792 1.296 0 2.424.264 3.408.792s1.752 1.248 2.28 2.208c.528.96.816 2.064.816 3.312 0 1.272-.288 2.376-.816 3.336s-1.296 1.68-2.28 2.208c-.984.528-2.112.768-3.408.768-1.296 0-2.448-.24-3.432-.768Zm5.664-2.976c.552-.648.84-1.512.84-2.568s-.288-1.896-.84-2.568c-.552-.648-1.296-.984-2.232-.984-.936 0-1.68.336-2.232.984-.552.672-.816 1.512-.816 2.568s.264 1.92.816 2.568c.552.672 1.296.984 2.232.984.936 0 1.68-.312 2.232-.984Zm16.886-7.536c.912.912 1.392 2.376 1.392 4.44v6.696h-3.384v-6.504c0-2.112-.84-3.192-2.496-3.192-.888 0-1.56.312-2.04.888-.48.6-.72 1.44-.72 2.496v6.312h-3.384V23.254h2.952l.312 1.536a4.322 4.322 0 0 1 1.56-1.224c.6-.288 1.344-.456 2.256-.456 1.44 0 2.616.456 3.552 1.344Zm6.405 7.032c.048.552.312.984.792 1.32.48.336 1.08.504 1.848.504.72 0 1.272-.096 1.704-.336.408-.24.624-.576.624-1.008 0-.312-.096-.552-.288-.72-.192-.144-.48-.264-.816-.336-.36-.072-.936-.168-1.728-.264-1.104-.144-1.992-.312-2.712-.552-.72-.216-1.296-.576-1.728-1.056-.432-.48-.648-1.104-.648-1.92 0-.792.216-1.488.648-2.112.432-.624 1.056-1.104 1.872-1.44.792-.336 1.704-.504 2.76-.504 1.68.024 3.024.384 4.056 1.08 1.032.72 1.584 1.68 1.68 2.928h-3.216c-.048-.456-.312-.84-.744-1.128-.432-.288-1.008-.456-1.68-.456-.648 0-1.176.12-1.56.36-.384.24-.576.576-.576.96 0 .288.096.504.312.648.192.144.48.264.816.312.336.072.888.144 1.68.216 1.656.192 2.928.552 3.816 1.08.888.528 1.344 1.416 1.344 2.664 0 .816-.24 1.512-.72 2.112-.48.624-1.128 1.08-1.968 1.416-.84.336-1.8.48-2.904.48-1.728 0-3.12-.36-4.176-1.128-1.08-.768-1.656-1.8-1.704-3.12h3.216Zm10.657-7.536c.384-.384.864-.576 1.464-.576.576 0 1.056.192 1.44.576.384.384.6.864.6 1.44s-.216 1.056-.6 1.44c-.384.384-.864.552-1.44.552-.6 0-1.08-.168-1.464-.552-.384-.384-.576-.864-.576-1.44s.192-1.056.576-1.44Zm0 8.352c.384-.384.864-.576 1.464-.576.576 0 1.056.192 1.44.576.384.384.6.864.6 1.44s-.216 1.056-.6 1.44c-.384.384-.864.552-1.44.552-.6 0-1.08-.168-1.464-.552-.384-.384-.576-.864-.576-1.44s.192-1.056.576-1.44Zm11.858-1.752c-.264-.96-.384-2.04-.384-3.192 0-1.824.264-3.408.84-4.728.552-1.296 1.344-2.304 2.4-2.976 1.032-.672 2.256-1.032 3.672-1.032 1.584 0 2.952.456 4.056 1.32 1.104.888 1.752 2.088 1.944 3.576h-3.408c-.168-.672-.504-1.176-.984-1.56-.504-.36-1.128-.552-1.872-.552-1.104 0-1.944.432-2.52 1.272-.576.84-.864 2.04-.864 3.576v.408l.216-.36c.384-.6.936-1.08 1.632-1.44a5.27 5.27 0 0 1 2.328-.528c1.104 0 2.088.24 2.952.72a5.091 5.091 0 0 1 2.016 2.016c.48.864.72 1.848.72 2.952 0 1.152-.264 2.136-.792 3a5.29 5.29 0 0 1-2.208 2.016c-.96.48-2.04.696-3.264.696-1.152 0-2.184-.216-3.096-.672a5.687 5.687 0 0 1-2.232-1.968c-.504-.72-.888-1.56-1.152-2.544Zm8.544-2.688c-.528-.552-1.2-.84-2.04-.84-.864 0-1.56.288-2.088.84-.528.576-.792 1.296-.792 2.16 0 .888.24 1.608.768 2.16.528.576 1.2.84 2.064.84.84 0 1.536-.264 2.064-.84s.792-1.296.792-2.16c0-.864-.264-1.584-.768-2.16Zm6.004-1.056c0-1.632.288-3.072.864-4.32.576-1.224 1.392-2.16 2.448-2.832 1.056-.672 2.256-1.008 3.6-1.008 1.344 0 2.544.336 3.6 1.008 1.056.672 1.872 1.608 2.448 2.832.576 1.248.888 2.688.888 4.32v.768c0 1.68-.312 3.144-.888 4.368-.576 1.224-1.392 2.16-2.448 2.808-1.056.672-2.256.984-3.6.984-1.368 0-2.568-.312-3.6-.984-1.056-.648-1.872-1.584-2.448-2.808-.576-1.224-.864-2.688-.864-4.368v-.768Zm9.432-3.816c-.624-.936-1.464-1.416-2.52-1.416s-1.896.48-2.52 1.416c-.624.936-.936 2.256-.936 3.936v.528c0 1.704.312 3.024.936 3.96.624.936 1.464 1.392 2.52 1.392s1.896-.456 2.52-1.392c.624-.936.96-2.256.96-3.96v-.528c0-1.68-.336-3-.96-3.936Zm16.476 11.472c-1.056.864-2.4 1.272-4.056 1.272-1.296 0-2.4-.24-3.36-.768a5.55 5.55 0 0 1-2.232-2.232c-.528-.96-.768-2.064-.768-3.312 0-1.248.24-2.352.768-3.312s1.272-1.68 2.232-2.208c.96-.528 2.088-.792 3.384-.792 1.632 0 2.976.432 4.032 1.272 1.032.84 1.68 1.992 1.92 3.48h-3.504c-.144-.6-.432-1.08-.864-1.44-.432-.36-.984-.552-1.608-.552-.888 0-1.584.336-2.112.984-.528.672-.792 1.512-.792 2.568s.264 1.92.792 2.568c.528.672 1.224.984 2.112.984.648 0 1.2-.168 1.632-.552.432-.36.72-.864.864-1.512h3.48c-.24 1.512-.864 2.688-1.92 3.552ZM453.62 24.43c.816.888 1.248 2.352 1.248 4.392v6.792h-3.384v-6.912c0-1.872-.72-2.808-2.136-2.808-.744 0-1.344.264-1.776.792-.456.528-.672 1.248-.672 2.16v6.768h-3.384v-6.912c0-1.872-.72-2.808-2.16-2.808-.744 0-1.344.288-1.776.816-.432.528-.648 1.248-.648 2.16v6.744h-3.384v-12.36h2.952l.312 1.536a4.291 4.291 0 0 1 1.488-1.224c.576-.288 1.296-.432 2.16-.456 1.752 0 2.976.696 3.672 2.088.432-.672 1.032-1.176 1.752-1.536.72-.36 1.56-.552 2.496-.552 1.32 0 2.4.456 3.24 1.32Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M490.736 218.82H30.852v2.87h459.884v-2.87Z",
    opacity: 0.5
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M1008.89 218.82H600.922v2.87h407.968v-2.87Z",
    opacity: 0.5
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M1318.21 251.31c18.78 0 34.01-15.228 34.01-34.012s-15.23-34.011-34.01-34.011c-18.79 0-34.01 15.227-34.01 34.011 0 18.784 15.22 34.012 34.01 34.012Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M1262.81 216.152h-261.04v7.348h261.04v-7.348Z",
    opacity: 0.5
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M1387.2 223.498c8.12 0 14.7-2.801 14.7-6.257 0-3.455-6.58-6.257-14.7-6.257-8.11 0-14.69 2.802-14.69 6.257 0 3.456 6.58 6.257 14.69 6.257Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 30.852,
    x2: 490.736,
    y1: 220.255,
    y2: 220.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#F8F8F8",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F1F1F1",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EDEDED",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E9E9E9",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7E7E7",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E7E7E7",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E8E8E8",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#EBEBEB",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EFEFEF",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F3F3F3",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F9F9F9",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 55.031,
    x2: 55.031,
    y1: 51.348,
    y2: 212.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69A4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 623.582,
    x2: 623.582,
    y1: 51.348,
    y2: 212.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69A4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 272.935,
    x2: 397.783,
    y1: -434.087,
    y2: 146.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69A4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 336.367,
    x2: 365.044,
    y1: 6.59,
    y2: 166.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69A4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 817.645,
    x2: 863.172,
    y1: 123.346,
    y2: 241.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69A4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 600.922,
    x2: 1008.89,
    y1: 220.255,
    y2: 220.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#F8F8F8",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F1F1F1",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EDEDED",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E9E9E9",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7E7E7",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E7E7E7",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E8E8E8",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#EBEBEB",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EFEFEF",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F3F3F3",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F9F9F9",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 1001.77,
    x2: 1262.81,
    y1: 219.826,
    y2: 219.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#F8F8F8",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F1F1F1",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EDEDED",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E9E9E9",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#E7E7E7",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E7E7E7",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E8E8E8",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#EBEBEB",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EFEFEF",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F3F3F3",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F9F9F9",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(1318.21 217.298) scale(34.0113)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fff",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fff",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#fff",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(14.6249 0 0 6.12204 1378.32 255.661)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fff",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fff",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#fff",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "c",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n",
    transform: "scale(.5)"
  })), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAYAAABytg0kAAAACXBIWXMAABibAAAYmwFJdYOUAAAAG0lEQVQIW2P8////fwYGBgYWBgYGx79//zIAAEg0BzqS5w0hAAAAAElFTkSuQmCC",
    id: "n",
    width: 2,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtwDesk);
export default __webpack_public_path__ + "static/media/otw-desk.2a844b4efbf39a24670db8a6b1f55f8b.svg";
export { ForwardRef as ReactComponent };